import React, {useState, useEffect, useRef} from 'react';
import ActionItemListSection from "./ActionItemListSection.mjs";
import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = false;

export default function ActionItemList({action_item_list}) 
{
    const { action_item, setActionItem, action_item_display_refresh, num_display_columns, 
            new_action_item_flag, setNewActionItemFlag, selected_action_item, setSelectedActionItem,
            action_item_list_local_refresh, setActionItemListLocalRefresh,
            setMainColumnDisplayType } = useCTAL();

    const [pending_action_items, setPendingActionItems] = useState([]);
    const [on_fire_action_items, setOnFireActionItems] = useState([]);
    const [hot_action_items, setHotActionItems] = useState([]);
    const [normal_action_items, setNormalActionItems] = useState([]);
    const [low_action_items, setLowActionItems] = useState([]);
    const initRef = useRef("");

    useEffect(() =>
    {
        if (!action_item_list) return;
        
        if ((initRef.id === action_item_list) && (!action_item_display_refresh)) return;
        initRef.id = action_item_list;

        split_action_item_list();

    }, [action_item_list,  action_item_display_refresh]);

    //Sept 18, 2023 - Used to reload full Action Item List, but now just 
    //                updating only the changed Action Item after the bulk fetch in ActionItem.mjs
    useEffect(() =>
    {
        if (action_item_list_local_refresh) {
            refresh_current_action_item_in_list();
            split_action_item_list();
        }

    }, [action_item_list_local_refresh]);

    const refresh_current_action_item_in_list = () => { 
        setActionItemListLocalRefresh(false);

        if ((!action_item) || (!action_item_list)) return;

        if (DEBUG) console.log(`ActionItemList*** - RECEIVED action_item_list_local_refresh for Action-Item ${action_item.Name}`)
              
        //Search and Replace updated Action Item
        for (var i=0; i < action_item_list.length; i++)
        {
            if (action_item_list[i].Name == action_item.Name)
            {
                action_item_list[i] = action_item;
                if (DEBUG) console.log(`ActionItemList*** - REFRESHING Action ${action_item.Name} - ${action_item.Summary}`)
            }
        }
    }

    const split_action_item_list = () => { 
        var pending_ai = action_item_list.filter(item => { return (item.AssignStatus === "Pending-Assignment"); });
        var on_fire_ai = action_item_list.filter(item => { return ((item.Priority === "On-Fire") && (item.AssignStatus != "Pending-Assignment")); });
        var hot_ai     = action_item_list.filter(item => { return ((item.Priority === "Hot") && (item.AssignStatus != "Pending-Assignment")); });
        var normal_ai  = action_item_list.filter(item => { return ((item.Priority === "Normal") && (item.AssignStatus != "Pending-Assignment")); });
        var low_ai     = action_item_list.filter(item => { return ((item.Priority === "Low") && (item.AssignStatus != "Pending-Assignment")); });

        setPendingActionItems( pending_ai );
        setOnFireActionItems ( on_fire_ai );
        setHotActionItems    ( hot_ai );
        setNormalActionItems ( normal_ai );
        setLowActionItems    ( low_ai );

        if ((new_action_item_flag) && (action_item_list.length > 0)) {
            console.log(`ActionItemList - initializing action item detail display to NEW: ${action_item_list[0].Name}`);
            setActionItem(action_item_list[0]);
            setNewActionItemFlag(false);
            setSelectedActionItem(); //Clear just in case
        }
        else if (selected_action_item) {
            //Sept 18, 2023 Removed setActionItem because this is the old Action-Item. It's enough not to select a different AI 
            //setActionItem(selected_action_item);
            setSelectedActionItem(); //Clear Selected Action Item now that we've set it to display 
        }
        else {
            var top_action_item;
            if      (pending_ai.length > 0) top_action_item = pending_ai[0];
            else if (on_fire_ai.length > 0) top_action_item = on_fire_ai[0];
            else if (hot_ai.length > 0)     top_action_item = hot_ai[0];
            else if (normal_ai.length > 0)  top_action_item = normal_ai[0];
            else if (low_ai.length > 0)     top_action_item = low_ai[0];

            if (top_action_item) {
                if (DEBUG) console.log(`ActionItemList - initializing action item detail display to: ${top_action_item.Name}`);
                setActionItem(top_action_item);
            }
            else
                setActionItem();
        }
    }

    const display_action_item = (action_item) => { 
        if (DEBUG) console.log(`ActionItemList - setting action item detail display to: ${action_item.Name}`);
        setActionItem(action_item);
        if (num_display_columns == 1)
            setMainColumnDisplayType("Action-Item");    
    }

    return ( 
        <> 
            < ActionItemListSection heading="Pending Acceptance" action_item_list_section={pending_action_items} displayActionItem={display_action_item} />
            < ActionItemListSection heading="On-Fire" action_item_list_section={on_fire_action_items} displayActionItem={display_action_item} />
            < ActionItemListSection heading="Hot"     action_item_list_section={hot_action_items}     displayActionItem={display_action_item} />
            < ActionItemListSection heading="Normal"  action_item_list_section={normal_action_items}  displayActionItem={display_action_item} />
            < ActionItemListSection heading="Low"     action_item_list_section={low_action_items}     displayActionItem={display_action_item} />
        </> 
    );
}